import { Autocomplete, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

FacilitySelector.propTypes = {
  facilities: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default function FacilitySelector({ facilities, value, onChange, isLoading, disabled, readOnly, ...props }) {
  return (
    <Autocomplete
      fullWidth
      size="small"
      value={facilities.length > 0 ? facilities.find((facility) => facility.value === value) ?? null : null}
      onChange={disabled || readOnly ? undefined : (_, newValue) => onChange(newValue?.value)}
      options={facilities}
      getOptionLabel={(option) => option?.label || ''}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select a facility"
          autoComplete="off"
          disabled={disabled}
          inputProps={{ ...params.inputProps, readOnly: readOnly || disabled }}
        />
      )}
      loading={isLoading}
      disabled={disabled}
      readOnly={readOnly}
      open={disabled || readOnly ? false : undefined}
      {...props}
    />
  );
}
